import React, { useEffect, useState } from "react";
import {
  DateInput,
  TextInput,
  SelectInput,
  CheckBoxInput,
  FileInput,
} from "../../components/common/ui/Inputs/index.js";
import Button from "../../components/common/ui/Button.jsx";
import postalMailSchema from "../../validation/postalMailSchema.js";
import { showToastNotification } from "../../components/common/ui/NotificationModal/ToastNotication.js";
import { history } from "../../_helpers/index.js";
import { useDispatch, useSelector } from "react-redux";
import { postalMailActions, authActions } from "../../_store";
import { masterActions } from "../../_store/master.slice.js";
import CustomLoader from "../../components/common/ui/Loader.jsx";
import { StoredProcedures } from "../../_helpers/enumerator";
import useManagementUserAccessPermission from "../../hooks/useManagementUserAccessPermission.jsx";
import { getStoredValue } from "../../_helpers/storagehelper.js";

function AddPostalMail() {
  const [mailDocumentInfo, setMailDocument] = useState({
    FolderPath: "",
    Filename: "",
    File: "",
    FacilityID: 0,
    FacilityCode: "",
    InmateID: 0,
    MailFrom: "",
    DocumentName: "",
    IsLegalMail: 0,
    CreatedBy: 0,
    Base64Data: "",
  });

  const { facilityInPostalMail: facilityOptions, loading } = useSelector(
    (x) => x.postalMail
  );
  const { PostalMailAccessPermission } = useManagementUserAccessPermission();
  const { user, commonFacilityCode } = useSelector((x) => x.auth);

  const { inmateFullNamewithId: inmateOptions } = useSelector((x) => x.master);
  const MAX_FILE_SIZE = parseInt(process.env.REACT_APP_MAX_FILESIZE, 10);
  const storeduser = getStoredValue("user");
  // Hide or Show Legal Mail checkbox
  const shouldShowChkLegalMail =
    Array.isArray(PostalMailAccessPermission) && PostalMailAccessPermission.length > 0
      ? PostalMailAccessPermission?.some(
        (item) =>
          item?.SubMenuName === "Legal Mail" &&
          item?.SubMenuActiveStatus === 1
      )
      : true;

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(masterActions.clearInmateOptions());
    dispatch(
      postalMailActions.LoadFacilityDropdown(
        user.ManagementUserID === 1 ? 0 : user.ManagementUserID
      )
    );

  }, [dispatch]);

  const [errorMessage, setErrorMessage] = useState({});

  // Handle file change for mail document
  const handleFileChange = (event) => {
    const file = event.target?.files[0]; // Get the selected file

    if (file === undefined) {
      setMailDocument((prev) => ({
        ...prev,
        Filename: "",
        File: "",
        DocumentName: "",
        Base64Data: "",
      }));
      setErrorMessage((prev) => ({
        ...prev,
        ["DocumentName"]: "Please upload Document.",
      }));
      return;
    }

    const fileName = file?.name?.replace(/\s+/g, "");

    const name = fileName.substring(0, fileName.lastIndexOf("."));
    const extension = fileName.substring(fileName.lastIndexOf("."));

    const now = new Date();
    const timestamp = now.getFullYear().toString() +
      String(now.getMonth() + 1).padStart(2, "0") +
      String(now.getDate()).padStart(2, "0") +
      String(now.getHours()).padStart(2, "0") +
      String(now.getMinutes()).padStart(2, "0") +
      String(now.getSeconds()).padStart(2, "0");

    const newFileName = `${name}_${timestamp}${extension}`;

    const maxSize = MAX_FILE_SIZE; // 25MB file size limit

    // Initialize switch cases
    switch (true) {
      // Case for no file selected
      case !file:
        // showToastNotification("No file selected", "error");
        return;

      // Case for invalid file type (not a PDF)
      case file.type !== "application/pdf":
        showToastNotification("Please upload a valid PDF file", "error");
        event.target.value = ""; // Clear the file input if invalid
        return;

      // Case for file size exceeding 25MB limit
      case file.size > maxSize:
        showToastNotification("File size exceeds the 20MB limit", "error");
        event.target.value = ""; // Clear the file input if too large
        return;

      // Default case for valid file
      default:
        // File is valid, proceed with reading the file
        const reader = new FileReader();
        reader.onloadend = () => {
          const base64Data = reader.result.split(",")[1]; // Extract base64 data

          // Update the state with the file name and base64 data
          setMailDocument((prevState) => ({
            ...prevState,
            Filename: newFileName,
            DocumentName: newFileName,
            File: base64Data,
            // Base64Data: base64Data,
          }));

          setErrorMessage((prev) => ({
            ...prev,
            DocumentName: "", // Clear the error message for documentName field
            Filename: "",
          }));
        };

        const element = document.querySelector(`[name="DocumentName"]`);
        if (element && element.classList.contains("input-error")) {
          element.classList.remove("input-error");
        }

        reader.readAsDataURL(file); // Read the file as base64
        break;
    }
  };

  const handleBack = () => {
    //setShowUploadForm(false);
    dispatch(masterActions.clearInmateOptions());
    history.navigate("/Admin/PostalMailList");
  };

  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setMailDocument({
      ...mailDocumentInfo,
      [name]: checked ? 1 : 0,
    });
  };

  const handleMailDocChange = (e, name) => {
    let value;

    // Determine the value based on input type
    if (e && e.target) {
      value = e.target.value;
    } else {
      value = e?.value ?? 0;
    }

    switch (name) {
      case "FacilityID":
        setMailDocument((prevState) => ({
          ...prevState,
          [name]: value,
          FacilityCode: e?.label ?? "",
          InmateID: 0,
        }));
        setErrorMessage((prev) => ({
          ...prev,
          ["FacilityCode"]: "", // Clear the error message for documentName field
        }));
        dispatch(masterActions.GetInmateFullNameWithID(value));
        break;

      default:
        // Default handling for other fields
        setMailDocument((prevState) => ({
          ...prevState,
          [name]: value,
        }));
        setErrorMessage((prev) => ({
          ...prev,
          [name]: "", // Clear the error message for documentName field
        }));

        break;
    }
  };

  const handleOnBlur = (e) => {
    let { name, value } = e.target;

    const { error } = postalMailSchema(mailDocumentInfo);

    if (error?.details) {
      // Extract the error message for the specific field
      const fieldError = error.details.find((e) => e.path.toString() === name);

      setErrorMessage((prev) => ({
        ...prev,
        [name]: fieldError ? fieldError.message : "", // Set the error message if exists, else clear it
      }));

      // Select the input element
      const element = document.querySelector(`[name="${name}"]`);

      if (element) {
        if (fieldError) {
          // Add the error class if there's a validation issue
          element.classList.add("input-error");
        } else {
          // Remove the error class if validation passes
          element.classList.remove("input-error");
        }
      }
    } else {
      // Clear the error message if there's no validation error
      setErrorMessage((prev) => ({
        ...prev,
        [name]: "",
      }));

      // Remove the error class from the input field
      const element = document.querySelector(`[name="${name}"]`);
      if (element) {
        element.classList.remove("input-error");
      }
    }
  };

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();

    setErrorMessage({});

    if (document?.getElementsByClassName("input-error").length > 0) {
      document
        .querySelectorAll(".input-error")
        .forEach((el) => el.classList.remove("input-error"));
    }

    const { error } = postalMailSchema(mailDocumentInfo);

    if (error?.details) {
      error?.details?.forEach((e) => {
        const { path } = e;
        // Set the error message for each invalid field
        setErrorMessage((prev) => ({
          ...prev,
          [path.toString()]: e.message,
        }));

        // Safely select the input element by name
        const inputElement = document.querySelector(`input[name="${path}"]`);
        if (inputElement) {
          // Add the input-error class if the element exists
          inputElement.classList.add("input-error");
        }
      });
      return;
    }

    mailDocumentInfo.CreatedBy = user?.ManagementUserID;
    dispatch(postalMailActions.UploadPostalMail(mailDocumentInfo)).then(
      (res) => {
        let result = res?.payload;

        if (mailDocumentInfo?.IsLegalMail != 1) {
          // dispatch(
          //   masterActions.GetLoadNotificationAlert({
          //     ManagementUserID: storeduser.ManagementUserID,
          //     FacilityID: getStoredValue("commonFacilityCode"),
          //     isNoLoading: true
          //   })
          // ).then((response) => {
          //   const updatedMenuList =
          //     getStoredValue("menu_list") || response?.payload;

          //   if (updatedMenuList) {
          //     dispatch(authActions.updateMenuList(updatedMenuList));
          //   }
          // });
        }
        if (result === 1) {
          // Insert Management User Activity Log
          dispatch(
            authActions?.ManagementUserActivityLog({
              ManagementUserID: user?.ManagementUserID,
              facilityID: commonFacilityCode,
              ProcedureName: StoredProcedures?.MailScanningDocumentUpload,
              UserAction: `Saved a New Postal Mail Document ( FacilityID - ${mailDocumentInfo.FacilityCode} & InmateID - ${mailDocumentInfo?.InmateID} )`,
            })
          );
          history.navigate("/Admin/PostalMailList");
          dispatch(postalMailActions.clearUploadResponse());
          dispatch(postalMailActions.clearPostalMail());
          showToastNotification("Document uploaded successfully", "success");
        } else if (result === -1) {
          showToastNotification("Please upload a valid PDF file", "error");
        }
      }
    );
  };

  const handleReset = () => {
    setErrorMessage({});

    if (document?.getElementsByClassName("input-error").length > 0) {
      document
        .querySelectorAll(".input-error")
        .forEach((el) => el.classList.remove("input-error"));
    }

    setMailDocument({
      ...mailDocumentInfo,
      FacilityID: 0,
      FacilityCode: "",
      InmateID: 0,
      MailFrom: "",
      IsLegalMail: 0,
      DocumentName: "",
      Base64Data: "",
    });
    dispatch(masterActions.GetInmateFullNameWithID(0));
  };

  if (loading) {
    return <CustomLoader />;
  }

  return (
    <>

      <div className="card  shadow-sm b-r-all  p-4 border border-dark-grey mt-3  w-100">
        <div className="d-flex flex-wrap justify-content-between align-items-center flex-wrap resp-space">
          <h2 className="form_title_uppercase text-color">
            MAIL DOCUMENT INFORMATION
          </h2>
          <Button
            variant="primary"
            className="me-2"
            label={"Back"}
            type={"button"}
            status={"primary"}
            onClick={handleBack}
            disabled={false}
            icon={"fa-solid fa-angle-left"}
          />
        </div>

        <div className="mt-2">
          <h4 className="inner-header-bg text-color">
            {" "}
            <i className="fa-solid fa-circle-info me-2"></i> MAIL DOCUMENT
            INFORMATION{" "}
          </h4>
          <form>
            <div className="row col-lg-12 mb-3">
              {/* <div className="row"> */}
              <div className="col-sm-6 col-md-6 col-lg-4 mb-1">
                <SelectInput
                  name="FacilityCode"
                  label="Facility Code"
                  options={facilityOptions}
                  value={mailDocumentInfo?.FacilityID}
                  handleChange={(e) => handleMailDocChange(e, "FacilityID")}
                  required={true}
                  errorMessage={errorMessage}
                  isClearable={mailDocumentInfo?.FacilityID !== 0}
                  handleBlur={() =>
                    handleOnBlur({ target: { name: "FacilityCode" } })
                  }
                />
              </div>
              <div className="col-sm-6 col-md-6 col-lg-4 mb-1">
                <TextInput
                  name="MailFrom"
                  label="Mail From"
                  value={mailDocumentInfo?.MailFrom}
                  handleChange={(e) => handleMailDocChange(e, "MailFrom")}
                  placeholder="Enter sender name"
                  maxLength={50}
                />
              </div>

              <div className="col-sm-6 col-md-6 col-lg-4 mb-1">
                <SelectInput
                  name="InmateID"
                  label="Choose Inmate"
                  options={inmateOptions}
                  value={mailDocumentInfo?.InmateID}
                  handleChange={(e) => handleMailDocChange(e, "InmateID")}
                  required={true}
                  errorMessage={errorMessage}
                  isClearable={mailDocumentInfo?.InmateID !== 0}
                  handleBlur={() =>
                    handleOnBlur({ target: { name: "InmateID" } })
                  }
                />
              </div>
              <div className="col-sm-6 col-md-6 col-lg-4 mb-1">
                <FileInput
                  label={"Mail Document"}
                  name={"DocumentName"}
                  showImage={false}
                  handleFileChange={handleFileChange}
                  value={mailDocumentInfo?.DocumentName || ""}
                  acceptFormat=".pdf"
                  errorMessage={errorMessage}
                  required={true}
                  handleBlur={() =>
                    handleOnBlur({ target: { name: "DocumentName" } })
                  }
                />
                <div className="fs-5">
                  <span className="text-danger">*</span>
                  <span className="text-gray">
                    {" "}
                    Note: Accepted Document Format is PDF only.
                  </span>
                </div>
              </div>

              {(user.UserRoleID === 1 ||
                user.UserRoleID === 3 ||
                user.UserRoleID === 12) && (
                  <div className="mb-3 col-lg-4">
                    {shouldShowChkLegalMail && (
                      <div className="mt-4 col-lg-4">
                        <CheckBoxInput
                          name="IsLegalMail"
                          label="Legal Mail"
                          id={"IsLegalMail"}
                          checked={mailDocumentInfo?.IsLegalMail || false}
                          handleClick={handleCheckboxChange}
                        />
                      </div>
                    )}
                    {shouldShowChkLegalMail && (
                      <div className="fs-5 mt-4">
                        <span className="text-danger">*</span>
                        <span className="text-gray">
                          {" "}
                          Note: If 'Legal Mail Checkbox' is selected, postal mail
                          will be sent directly to the inmate and you will not be
                          able to reject it.
                        </span>
                      </div>
                    )}
                  </div>
                )}
            </div>

            <div className="d-flex flex-wrap justify-content-center mt-3 gap-3 mb-5">
              <Button
                className="me-2"
                label={"Save"}
                type="submit"
                variant="danger"
                status={"success"}
                onClick={(e) => handleSubmit(e)}
                disabled={false}
                icon={"fa-solid fa-floppy-disk"}
              />
              <Button
                className="me-2"
                label="Reset"
                type="reset"
                variant="danger"
                status={"secondary"}
                onClick={handleReset}
                disabled={false}
                icon={"fa-solid fa-rotate-right"}
              />
            </div>
          </form>
        </div>
      </div>
    </>
  );
}

export default React.memo(AddPostalMail);
